import * as React from 'react';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepConnector, {
  stepConnectorClasses,
} from '@mui/material/StepConnector';
import CheckIcon from '@mui/icons-material/Check';
import { useTheme } from '@mui/styles';
import { useMediaQuery } from '@mui/material';

export default function CustomStepperAgent({ stepValue }) {
  const steps = ['Preparing Contract', 'Sign Pending', 'Contract Signed'];

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const FinishedStep = () => {
    return (
      <svg
        width={matchessm ? '15' : '25'}
        height={matchessm ? '15' : '25'}
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12.5" cy="12.5" r="12.5" fill="#6C2AD2" />
        <path
          d="M8 12.9167L10.9167 15.8333L16.75 10"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };

  const WaitingStep = () => {
    return (
      <svg
        width={matchessm ? '15' : '25'}
        height={matchessm ? '15' : '25'}
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12.5" cy="12.5" r="12.5" fill="#E6F2FF" />
      </svg>
    );
  };

  const CustomStepIconRoot = styled('div')(({ ownerState }) => ({
    zIndex: 1,
    width: matchessm ? 20 : 32,
    height: matchessm ? 20 : 32,
    display: 'flex',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: ownerState.completed
      ? '#7C3AED'
      : ownerState.active
      ? '#7C3AED'
      : '#fff',
    color: ownerState.completed || ownerState.active ? '#fff' : '#7C3AED',
    boxShadow:
      ownerState.active || ownerState.completed
        ? 'none'
        : '0 0 4px rgba(0,0,0,0.1)',
  }));

  const CustomConnector = styled(StepConnector, {
    shouldForwardProp: (prop) => prop !== 'currentStep',
  })(({ currentStep }) => ({
    width: '100%',
    marginLeft: '-10px',
    [`& .${stepConnectorClasses.line}`]: {
      height: 1.4,
      border: 0,
      backgroundColor: '#fff',
    },
    [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
      backgroundColor: '#6C2AD2',
    },
    [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
      backgroundColor: currentStep > 1 ? '#6C2AD2' : '#fff',
    },
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
      top: matchessm ? 10 : 14,
    },
  }));

  function CustomStepTicIcon(props) {
    const { icon, className } = props;
    const stepNum = Number(icon);

    const isCompleted = stepNum < stepValue;
    const isCurrent = stepNum === stepValue;

    return (
      <CustomStepIconRoot
        ownerState={{ completed: isCompleted, active: isCurrent }}
        className={className}
      >
        {isCompleted ? <FinishedStep /> : isCurrent ? null : <WaitingStep />}
      </CustomStepIconRoot>
    );
  }

  return (
    <Stack sx={{ width: '100%' }}>
      <Stepper
        alternativeLabel
        activeStep={stepValue - 1}
        connector={<CustomConnector currentStep={stepValue} />}
      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel
              StepIconComponent={CustomStepTicIcon}
              sx={{
                paddingBottom: matchessm ? '10px' : 'auto',
                color: '#ffffff !important',
                '.MuiStepLabel-label': {
                  fontFamily: 'Poppins',
                  color: '#ffffff !important',
                  fontSize: '10px',
                  fontWeight: '300',
                },
                '.Mui-active .MuiStepLabel-label': {
                  color: '#ffffff !important', // override active step color
                },
                '.Mui-completed .MuiStepLabel-label': {
                  color: '#ffffff !important', // optional: keep white for completed as well
                },
              }}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Stack>
  );
}
